const Shared = require("Sources/shared");
const Utils = require("Sources/utils/utils");

import ChickenGame from "Sources/games/chicken-game";

require("Styles/pages/games-chicken.scss");

$(function()
{
  Shared.init();
  GamesChickenPage.init();
});

var GamesChickenPage = {};

((GamesChickenPage) =>
{
  let game = null;

  GamesChickenPage.init = function()
  {
    Utils.ImageSVGToSVG();

    game = ChickenGame("games-chicken");

    setUpCanvasScaler();
  };

  function setUpCanvasScaler()
  {
    window.onload = () => {
      resize();
      window.addEventListener("resize",resize,false)
    }
  }

  function resize()
  {
    let $container = $("#games-chicken");
    let canvas = $container.find("canvas").get(0);

    let width = Math.min($container.width(), game.config.width);
    let height = game.config.height / game.config.width * width;
    let wratio = width / height;
    let ratio = game.config.width / game.config.height;

    if(wratio < ratio)
    {
      canvas.style.width = width + "px";
      canvas.style.height = (width / ratio) + "px";
    }
    else
    {
      canvas.style.width = (height * ratio) + "px";
      canvas.style.height = height + "px";
    }
  }
})(GamesChickenPage);



// WEBPACK FOOTER //
// ./app/js/entries/games-chicken.js